export default "__VITE_ASSET__DvIUv3ob__"